export const menuConfig = [
  {
    type: 'dropdown',
    root: 'Assets',
    children: ['Layer', 'Segments', 'Connection Hub'],
  },
  {
    type: 'dropdown',
    root: 'Planning',
    children: ['Builder', 'Beacons', 'POI', 'AI Targeting', 'DOOH Planner'],
  },
  {
    type: 'dropdown',
    root: 'Analytics',
    children: ['Map', 'Query Lab', 'Notebook', 'Intelligence', 'Dashboard'],
  },
  {
    type: 'button',
    root: 'Marketplace',
    children: ['Marketplace'],
    route: 'marketplace',
  },
]
